// extracted by mini-css-extract-plugin
export default {"switcher_container":"index_switcher_container__cJ8v2","switcher_container1":"index_switcher_container1__a9H9d"};